module.exports = __webpack_public_path__ + "img/stock3.b9d1cb2d.png";